import $ from 'jquery';

class Search {
  constructor() {
    this.$form = $('#searchform');
    this.$input = this.$form.find('.header__search_input');
    this.$searchToggle = this.$form.find('.js-search-trigger');
    this.events();
  }

  events() {
    this.$searchToggle.click(e => {
      e.preventDefault();
      if (!this.isInputActive()) {
        this.openInput();
      }
      else {
        this.closeInput();
      }
    });

    $(document)
      .click(e => {
        if (this.$form !== e.target && !this.$form.has(e.target).length) {
          this.closeInput();
        }
      })
      .on('keyup keydown', e => {
        if (e.key === 'Escape' && this.isInputActive()) {
          this.closeInput();
        }
      });
  }

  openInput() {
    this.$form.addClass('active');
    setTimeout(() => {
      this.$input.focus();
    }, 100);
  }

  closeInput() {
    this.$form.removeClass('active');
    this.$input.val('');
  }

  isInputActive() {
    return this.$form.hasClass('active');
  }

}

export default Search;
